import React from 'react';
import { strings } from '../../../../../common/resources/locales/i18n';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import LazyLoad from "react-lazyload";

//Components
import { AsyncImage } from '../../../components/AsyncImage';

//Resources
import ModelsManager from "../../../../../common/modules/models/ModelsManager";

const ModelsItem = (props) => {
  const { bestFinalPrice, description, image, bestCuotaPriceFormat, urlKey, alt, routing, backgroundColor, tags } = props;

  return (
      <Link to={`${routing}${urlKey}`} className="card card-model h-100">
        <div className="backColor color-bg" style={{backgroundColor: backgroundColor || "var(--primary)"}}></div>

        <div className="card-header position-relative pb-0">
          <div className="card-product-tags">
            {tags && tags.map((item, key)=>{
              const backgroundHexColor = ModelsManager.getBackgroundHexColor(item)
              const tagText = ModelsManager.getTagText(item)
              const textHexColor = ModelsManager.getTextHexColor(item)

              return(
                <div key={key} className="card-tag bg-new small" style={{backgroundColor: backgroundHexColor, color: textHexColor }}>
                  {tagText || ''}
                </div>
              )
            })}

          </div>

          <figure className="embed-responsive embed-responsive-16by9 mb-0">
            <LazyLoad>
            <AsyncImage
              styleContainer='item'
              source={image}
              style='card-img-top embed-responsive-item'
              minHeightLoading='184px'
              minWidthLoading='225px'
              alt={alt}
            />
            </LazyLoad>
          </figure>
        </div>

        <div className="card-body text-center pt-4">
          <h3 className="h4 text-dark mb-0">{description}</h3>
          <div className="big-md text-secondary mb-0"><small
            className="text-dark text-muted">{strings('models.from')}</small> <strong>{bestCuotaPriceFormat}</strong>
          </div>
          {bestFinalPrice ?
            <div className="big-md text-dark"><small className="text-muted">{strings('models.pvp')}</small>
              <strong> {bestFinalPrice}</strong></div> : <></>}
          <div className="card-body-hidden">
            <div className="btn btn-secondary btn-block">{strings('models.seeInStock')}</div>
          </div>
        </div>

      </Link>
      )
      }

      ModelsItem.propTypes = {
      id: PropTypes.string,
      bestFinalPrice: PropTypes.string,
      description: PropTypes.string,
      image: PropTypes.string,
      vehiclesCount: PropTypes.number,
    };

      export default ModelsItem
